export default {
  initialMessage: "Ahoj, s čím ti dnes můžu pomoci?",
  placeholders: {
    writeMessage: "Napište zprávu...",
  },
};
